import React from 'react';
import PropTypes from 'prop-types';
import { NestDocumentLevel } from 'providers/DocumentLevel';

export const Section = ({ children, ...attrs }) => (
  <NestDocumentLevel>
    <section {...attrs}>{children}</section>
  </NestDocumentLevel>
);

Section.propTypes = {
  children: PropTypes.node,
};
